import React, { Component, useContext } from 'react';

import { fontCaptionMedium } from '../../styles/typographyNew';
import { Dropdown } from '../../components/Dropdown';
import { BrandSystemContext } from '../../contexts/BrandSystemContext';
import { classNames } from '../../utils/style';

export interface LanguageType {
  label: string;
  LinkAs?: string | typeof Component;
  linkProps: any;
  navigate?: (url: string) => void;
}

export interface LanguagesType {
  [key: string]: LanguageType;
}
export const LanguagesDropdown = ({
  languages,
  alignment,
  className,
  position,
}: {
  languages: LanguagesType;
  alignment?: 'right' | 'left';
  position?: 'top' | 'bottom';
  className?: string;
}) => {
  const theme = useContext<any>(BrandSystemContext);

  let _language = theme.language.toUpperCase();
  if (_language === 'EN') _language = 'English';
  if (_language === 'FR') _language = 'Français';
  if (_language === 'ES') _language = 'Español';

  return (
    <div className={classNames('LanguagesToggle', className)}>
      <Dropdown>
        <Dropdown.Button>
          <div className="flex items-center gap-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mr-[3px]"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.60962 7.99964C1.60962 4.47039 4.47064 1.60938 7.99988 1.60938C8.89412 1.60938 9.74546 1.79306 10.5182 2.12475V2.55752C10.5182 3.06672 10.316 3.55506 9.9559 3.91512C9.59584 4.27518 9.10749 4.47745 8.5983 4.47745C8.34073 4.47731 8.08578 4.529 7.84861 4.62943C7.61143 4.72986 7.39689 4.87698 7.21775 5.06204C7.03861 5.2471 6.89854 5.46631 6.80588 5.70663C6.71321 5.94694 6.66984 6.20344 6.67836 6.46086V8.04759C6.67836 8.29972 6.6287 8.54938 6.53221 8.78231C6.43573 9.01525 6.2943 9.2269 6.11602 9.40519C5.93774 9.58347 5.72609 9.72489 5.49315 9.82138C5.26021 9.91786 5.01055 9.96752 4.75842 9.96752H2.82262H1.91836C1.71792 9.34762 1.60962 8.68628 1.60962 7.99964ZM11.1589 13.5557C12.5219 12.7791 13.5714 11.5153 14.0704 10.0013L13.824 9.82068C13.323 9.56175 12.7685 9.42313 12.2046 9.41584H10.0648C9.62637 9.45566 9.2187 9.65795 8.92184 9.983C8.62497 10.308 8.46037 10.7323 8.46037 11.1726C8.46037 11.6128 8.62497 12.0371 8.92184 12.3621C9.2187 12.6872 9.62637 12.8894 10.0648 12.9293C10.2293 12.9273 10.3925 12.9581 10.5451 13.0197C10.6976 13.0814 10.8364 13.1726 10.9534 13.2883C11.0339 13.3679 11.103 13.4579 11.1589 13.5557ZM7.99988 0.109375C3.64221 0.109375 0.109619 3.64197 0.109619 7.99964C0.109619 12.3573 3.64221 15.8899 7.99988 15.8899C12.3576 15.8899 15.8901 12.3573 15.8901 7.99964C15.8901 3.64197 12.3576 0.109375 7.99988 0.109375Z"
                fill="#768699"
              />
            </svg>
            <span className={classNames(fontCaptionMedium, 'text-navy-200')}>
              {_language}
            </span>
            <span aria-hidden={true}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.9998 4.85833L12.6415 7.5L13.8165 6.325L9.9998 2.5L6.1748 6.325L7.35814 7.5L9.9998 4.85833ZM9.9998 15.1417L7.35814 12.5L6.18314 13.675L9.9998 17.5L13.8248 13.675L12.6415 12.5L9.9998 15.1417Z"
                  fill="#96A3B3"
                />
              </svg>
            </span>
          </div>
        </Dropdown.Button>
        <Dropdown.Content alignment={alignment} position={position}>
          {Object.entries(languages).reduce((acc: any[], [key, value]: any) => {
            if (key !== theme.language) {
              if (value)
                acc.push(
                  <Dropdown.Element
                    as={value.LinkAs}
                    id={key}
                    key={key}
                    {...value.linkProps}
                  >
                    {value.label}
                  </Dropdown.Element>,
                );
            }

            return acc;
          }, [])}
        </Dropdown.Content>
      </Dropdown>
    </div>
  );
};
